import { KitType } from '@repo/types';
import { Typography } from '@repo/ui';
import useGutBodyConnections from 'hooks/useGutBodyConnections';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import ConditionMetricCard from '../../ConditionMetricCard';
import FlaggedMetricsCount from '../../FlaggedMetricsCount';
import ConditionLinkCard from '../../NewConditionMetricsList/ConditionLinkCard';
import styles from '../ConditionsEducationalModal.module.css';
import { CARD_CONFIG } from '../utils/sensitiveSlideConfig';

export default function SensitiveMetricFlagsSlide() {
  const { currentKitType = KitType.STOOL } = useCurrentKitAndTinyAccount();
  const gutBodyConnections = useGutBodyConnections();

  const { name, evaluationCounts } = CARD_CONFIG[currentKitType];

  return (
    <>
      <Typography variant='heading-l' className={styles.headingText}>
        Flags in conditions you're not experiencing? Don't worry.
      </Typography>
      {gutBodyConnections ? (
        <ConditionLinkCard
          name={name}
          trailing={<FlaggedMetricsCount flagged={3} total={10} />}
          className={styles.conditionLinkCard}
        />
      ) : (
        <div className={styles.legacyCardWrapper}>
          <ConditionMetricCard
            title={name}
            evaluationCounts={evaluationCounts}
          />
        </div>
      )}

      <Typography
        variant='body-s'
        className={styles.headingText}
        color='warm-grey-700'
      >
        Remember — associations should be treated as informational, not
        diagnostic. It doesn't mean you have the condition or will develop it.
      </Typography>
    </>
  );
}
